export default ({ common: { errors } }) => {
  const mostRecentError = errors[errors.length - 1];
  if (mostRecentError) {
    return !!mostRecentError.canBeRetried;
  }

  return false;
};
